import { Body, Heading, Icon, IconType } from '@assembly-js/design-system';

export const SIDEBAR_NOTIFICATION_CARD_HEIGHT = 48;

type SidebarNotificationCardProps = {
  icon: IconType;
  title: string;
  description: string;
  onClick: () => void;
  /** Adds a close button, revealed when the surrounding stack is hovered. */
  onDismiss?: () => void;
  dismissLabel?: string;
  testId?: string;
};

export function SidebarNotificationCard({
  icon,
  title,
  description,
  onClick,
  onDismiss,
  dismissLabel,
  testId,
}: SidebarNotificationCardProps) {
  return (
    // Preflight is off, so without box-border the border would add 2px to
    // the 48px the stack lays cards out by.
    <div
      className="relative box-border h-12 w-full rounded border border-solid border-secondary-hover bg-white"
      data-testid={testId}
    >
      <button
        // Dismissible cards keep the title clear of the corner close button.
        className={`box-border flex size-full cursor-pointer appearance-none items-center gap-2 border-0 bg-transparent py-1.5 pl-2 text-left ${
          onDismiss ? 'pr-8' : 'pr-3'
        }`}
        onClick={onClick}
        type="button"
      >
        <span className="flex shrink-0 items-center justify-center rounded bg-secondary-hover p-[9px]">
          <Icon className="size-3.5 text-light-gray" icon={icon} />
        </span>
        <span className="flex min-w-0 flex-1 flex-col">
          <Heading
            className="mb-0! truncate leading-[20px] text-black-heading"
            size="xs"
            tag="span"
          >
            {title}
          </Heading>
          <Body
            className="truncate text-[10px]! leading-[16px] text-secondary"
            size="xs"
            tag="span"
          >
            {description}
          </Body>
        </span>
      </button>
      {onDismiss && (
        <button
          aria-label={dismissLabel}
          className="absolute right-3 top-[9px] flex cursor-pointer appearance-none items-center border-0 bg-transparent p-0 text-gray-300 opacity-0 transition-opacity hover:text-secondary group-hover/notifications:opacity-100 group-focus-within/notifications:opacity-100"
          onClick={onDismiss}
          type="button"
        >
          <Icon className="size-3.5" icon="Close" />
        </button>
      )}
    </div>
  );
}
